module.exports = __webpack_public_path__ + "static/media/copyright_logo.b51b9fd5.svg";